import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';

// import routes
import Routes from './routes';
import { useEffect } from 'react';
import { db } from './lib/firebase/index';
import { getAuth, signInAnonymously } from "firebase/auth";
import { Cloudinary } from '@cloudinary/url-gen';

export function App () {

     // Cloudinary configuration
     const cld = new Cloudinary({
        cloud: {
            cloudName:'fama-art',
        },
    });

    return (
        <BrowserRouter basename={ '/' } >
            <ScrollContext>
                <Routes />
            </ScrollContext>
        </BrowserRouter>
    )
}


ReactDOM.render( <App />, document.getElementById( 'app' ) );